exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dialog-info-wrapper .dialog-info .info-message[data-v-6c0c924d] {\n  padding: 0 0 27px 6px;\n  font-weight: 400;\n}\n.dialog-info-wrapper .dialog-info .info-message .info[data-v-6c0c924d] {\n  display: inline-block;\n  width: auto;\n  padding: 0 20px;\n}\n.dialog-info-wrapper .dialog-info .info-message .info .message[data-v-6c0c924d] {\n  color: #2f3135;\n  font-size: 12px;\n  padding-top: 10px;\n  overflow: hidden;\n  max-height: 200px;\n  white-space: pre-wrap;\n}\n", ""]);

// exports
